import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { JOURNAL } from "../mock";
import Reveal from "./Reveal";

const Journal = () => {
  return (
    <section id="journal" className="bg-[#F5F2ED] border-y border-[#E9E5DE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="flex items-end justify-between gap-6 mb-12">
          <Reveal className="max-w-xl">
            <p className="font-body text-sm text-[#2B4BFF] font-semibold mb-3">{JOURNAL.kicker}</p>
            <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0B1533] leading-[1.05]">
              {JOURNAL.title}
            </h2>
          </Reveal>
          <Link
            to="/ratgeber"
            className="hidden sm:inline-flex items-center gap-2 font-body font-semibold text-[#2B4BFF] shrink-0 hover:gap-3 transition-all duration-200"
            data-testid="journal-blog-link"
          >
            Blog <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid sm:grid-cols-3 gap-6">
          {JOURNAL.items.map((post, i) => (
            <Reveal key={post.title} delay={i * 100}>
              <Link
                to={post.link || "/ratgeber"}
                data-testid={`journal-card-${i}`}
                className="group flex flex-col h-full rounded-3xl overflow-hidden bg-white border border-[#E9E5DE] cursor-pointer hover:border-[#2B4BFF] hover:elev-soft transition-all"
              >
                <div className="h-44 overflow-hidden">
                  <img
                    src={post.img}
                    alt={post.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                </div>
                <div className="p-6">
                  <span className="font-body text-xs font-semibold text-[#2B4BFF] bg-[#EEF1FF] rounded-full px-3 py-1">
                    {post.tag}
                  </span>
                  <h3 className="font-heading font-semibold text-lg tracking-tight text-[#0B1533] leading-snug mt-3">
                    {post.title}
                  </h3>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journal;
